import  React from 'react';
import styles from 'bundle-text:./styles.css';
import 'regenerator-runtime/runtime'

const LoaderForm = ({active = false}) => (
    <React.Fragment>        
        <style>
            {styles}
        </style>
        <div className={`loader ${active ? 'active' : ''}`}>
            <div className="circles primary"></div>
            <div className="circles secondary"></div>
        </div>
    </React.Fragment>
);

export default LoaderForm;